/* EI homepage, Shop by category: tilt the product toward the pointer while a card is hovered.
   Fine pointers only, and only when motion is allowed (.ei-js on <html>, set in ei-head).
   pointermove only stores the position; one animation frame writes --ei-tx / --ei-ty (-1..1). */
(function () {
  /* Sections marked data-ei-cv use content-visibility: auto, so one that has not been shown yet only
     holds an estimated height. Render the ones above the target first so the scroll lands exactly. */
  function settle(target) {
    var cv = document.querySelectorAll('[data-ei-cv]');
    for (var i = 0; i < cv.length; i++) {
      if (cv[i].compareDocumentPosition(target) & 4) cv[i].style.contentVisibility = 'visible';
    }
  }

  /* In-page links (#id) scroll natively (the theme makes that smooth). Settle the estimated sections
     above the target first, so the browser computes the final spot from real heights. Registered once. */
  if (!window.__eiCvLinks) {
    window.__eiCvLinks = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a || !a.hash || a.hash.length < 2 || a.href.split('#')[0] !== location.href.split('#')[0]) return;
      var t;
      try { t = document.getElementById(decodeURIComponent(a.hash.slice(1))); } catch (err) { return; }
      if (t) settle(t);
    }, true);
  }

  var root = document.documentElement;
  if (!root.classList.contains('ei-js')) return;
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var cur = null, px = 0, py = 0, raf = 0;

  function set(card, x, y) {
    card.style.setProperty('--ei-tx', x);
    card.style.setProperty('--ei-ty', y);
  }
  function apply() {
    raf = 0;
    if (!cur) return;
    var r = cur.getBoundingClientRect();
    var x = Math.max(-1, Math.min(1, ((px - r.left) / r.width) * 2 - 1));
    var y = Math.max(-1, Math.min(1, ((py - r.top) / r.height) * 2 - 1));
    set(cur, x.toFixed(3), y.toFixed(3));
  }
  function leave() {
    if (cur) set(cur, 0, 0);
    cur = null;
  }

  document.querySelectorAll('[data-ei-cat-grid]').forEach(function (grid) {
    grid.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var card = e.target.closest('.ei-cat-card');
      if (card !== cur) leave();
      cur = card;
      px = e.clientX;
      py = e.clientY;
      if (cur && !raf) raf = requestAnimationFrame(apply);
    }, { passive: true });
    grid.addEventListener('pointerleave', leave);
  });
})();
